<app-splash-screen></app-splash-screen>
<div class="pageWrapper active" [ngClass]="{ hmenu: isMenuOpen, 'sidebar-hidden': !sidebarMenu }" [attr.data-category]="pagename">
  <p-sidebar [(visible)]="sidebarMenu" id="pSidebar" styleClass="{{ sidebarMenuClass ? 'show-lg' : 'show-lg' }}"
    [baseZIndex]="101" *showField="'APP_SIDE_NAVBAR'" [closeOnEscape]="false">
    <div class="leftNavigation no-print clearfix">
      <app-page-header (menuToggle)="handleMenuToggle($event)"></app-page-header>
    </div>
  </p-sidebar>
  <div class="contentWrapper" [ngClass]="{ 'show-lg': sidebarMenuClass, 'ml-0': !showNavbar }">
    <div class="clearfix">
      <header class="header">
        <nav class="navbar navbar-light navbar-expand-lg" aria-label="navbar">
          <button class="navbar-toggler" type="button" data-toggle="collapse" (click)="sidebar($event)"
            (touchstart)="sidebar($event)">
            <span class="material-symbols-outlined text-primary">menu</span>
          </button>
          <div class="navbar-brand">
            <div class="content-header d-flex align-items-center">
              <div class="d-lg-flex d-none flex-column">
                <div class="content-text" *ngIf="isString(pagename); else elsepart">{{ pagename }}</div>
                <!-- <div class="content-text" *ngIf="isString(pagename); else elsepart"></div> -->
              </div>
            </div>
          </div>

          <ng-template #elsepart>
            <div class="content-text">{{ previouslySelectedMenu }}</div>
          </ng-template>

          <div class="d-lg-none d-flex ml-md-auto">
            <span class="notification mr-2">
              <a class="nav-link d-flex align-items-center notification-pointer" 
                *showField="'APP_HEADER_NOTIFICATION'">
                <div class="menuIcons d-inline-block position-relative" (click)="gotoNotification()">
                  <small class="badge notif-count" *ngIf="showCount">{{
                    notificationCount ? notificationCount : 0
                    }}</small>
                  <span class="material-symbols-outlined material-icons">notifications</span>
                </div>
              </a>
            </span>

            <span class="mobile-profile userprofile position-relative">
              <a *showField="'APP_HEADER_PROFILE'" class="nav-link d-flex" href="javascript:void(0)"
                id="navbarDropdownMenuLinkOne" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                <div class="menuIcons d-flex">
                  <img [src]="thumbnail" width="25" alt="profile-pic" class="thumbnail" />
                </div>
              </a>
              <div class="dropdown-menu" aria-labelledby="navbarDropdownMenuLinkOne">
                <div class="dropdown-header d-flex flex-column justify-content-center px-3 py-2 border-bottom">
                  <span class="username">{{ showname }}</span>
                </div>
                <a class="dropdown-item d-flex align-items-center" href="javascript:void(0)" [routerLink]="'profile'"
                  *showField="'APP_HEADER_PROFILE'">
                  <span class="material-icon material-symbols-outlined mr-2">settings</span>
                  Settings
                </a>
                <a class="dropdown-item d-flex align-items-center" href="javascript:void(0)" (click)="onLoggedout()">
                  <span class="material-icon material-symbols-outlined mr-2">logout</span>
                  Log Out
                </a>
              </div>
            </span>
          </div>
          <div class="collapse navbar-collapse dashboard-list" id="dashboardItems">
            <ul class="navbar-nav ml-lg-auto flex-lg-row">
              <li class="nav-item notification d-lg-flex d-none mr-2">
                <a class="nav-link d-flex align-items-center notification-pointer"
                  *showField="'APP_HEADER_NOTIFICATION'">
                  <div class="menuIcons d-inline-block position-relative" (click)="gotoNotification()">
                    <small class="badge notif-count" *ngIf="showCount">{{
                      notificationCount ? notificationCount : 0
                      }}</small>
                    <span class="material-symbols-outlined material-icons">notifications</span>
                  </div>
                </a>
              </li>
              <li class="nav-item overllmenu d-none dropdown mr-0">
                <a *showField="'APP_HEADER_CONNECTIONS'" class="nav-link d-flex align-items-center notification-pointer"
                  id="navbarDropdownMenuLinkTwo" data-toggle="dropdown" aria-haspopup="true"
                  aria-expanded="false">
                  <div class="menuIcons">
                    <span class="material-symbols-outlined material-icons">apps</span>
                  </div>
                </a>
                <div class="dropdown-menu" aria-labelledby="navbarDropdownMenuLinkTwo">
                  <div class="row">
                    <div class="col">
                      <a (click)="gotoVideoConfig()">
                        <figure class="text-center">
                          <img src="/assets/images/video-call.svg" alt="video-call" width="28" />
                          <figcaption class="mt-1">Video Call</figcaption>
                        </figure>
                      </a>
                    </div>
                    <div class="col">
                      <a (click)="gotoEmailTemp()">
                        <figure class="text-center">
                          <img src="/assets/images/Email.svg" alt="Email" width="28" />
                          <figcaption class="mt-1">Email</figcaption>
                        </figure>
                      </a>
                    </div>
                    <div class="col"></div>
                  </div>
                </div>
              </li>
              <!-- search component -->

              <li *showField="'APP_HEADER_GLOBALSEARCH'"
                class="nav-item userprofile position-relative d-lg-flex d-none mr-4">
                <div class="d-flex align-items-center" #trigger>
                  <span class="p-input-icon-left">
                    <i class="pi pi-search"></i>
                    <input type="text" pInputText class="form-control" (click)="openPopup()" placeholder="Search..."
                      aria-label="Global search" role="search">
                  </span>
                </div>

                <!-- Full-Screen Popup -->
                <div class="search-popup" *ngIf="isPopupVisible" #popup>
                  <!-- Close Icon (Moved Out of popup-content) -->
                  <div class="popup-content p-5 position-relative">
                    <input type="text" class="form-control p-4" [(ngModel)]="searchQuery" (input)="onSearchInput()"
                      placeholder="Type to search..." autofocus aria-label="Search query"
                      (keydown.escape)="closePopup()">
                    <span class="close-icon" (click)="closePopup()" aria-label="Close search" tabindex="0"
                      (keydown.enter)="closePopup()">&#10006;</span>
                    <div class="search-results overflow-y-auto mt-4">

                      <!-- Loading Indicator -->
                      <div *ngIf="isSearching" class="text-center my-4">
                        <i class="pi pi-spin pi-spinner" style="font-size: 2rem"></i>
                        <p class="mt-2">Searching...</p>
                      </div>

                      <!-- Error Message -->
                      <div *ngIf="searchError" class="alert alert-danger">
                        {{ searchError }}
                      </div>

                      <div *ngIf="getTotalCount() === 0" class="text-center text-muted mt-4">
                        <i class="pi pi-exclamation-triangle mr-2"></i>
                        <div>No results found.</div>
                      </div>

                      <div class="container mb-5">
                        <ul class="nav nav-tabs mb-3 border-bottom">
                          <!-- "All" Tab -->
                          <li class="nav-item mr-4" *ngIf="getTotalCount() > 0">
                            <a class="nav-link px-4 py-2
                                     text-primary" [ngClass]="{
                               'activeTabItem': activeTab === 'all'
                             }" (click)="setActiveTab('all')" style="cursor: pointer;">
                              All <span class="badge bg-info ms-1 text-white">{{ getTotalCount() }}</span>
                            </a>
                          </li>

                          <!-- Dynamic Tabs for Each Index -->
                          <li class="nav-item mr-4 " *ngFor="let group of groupedResults | keyvalue">
                            <a class="nav-link px-4 py-2
                                     text-primary" [ngClass]="{
                               'activeTabItem': activeTab === group.key
                             }" (click)="setActiveTab(group.key)" style="cursor: pointer;">
                              {{ group.key }} <span class="badge bg-info ms-1 text-white">{{ group.value.length
                                }}</span>
                            </a>
                          </li>
                        </ul>

                        <div class="row gy-4 col-12">
                          <!-- Iterate Over Grouped Results or Show All if "All" Tab is Selected -->
                          <div *ngFor="let group of groupedResults | keyvalue; trackBy: trackByGroupKey" class="col-12"
                            [class.d-none]="activeTab !== 'all' && activeTab !== group.key">

                            <!-- Row for Each Index and Its Details -->
                            <div class="row align-items-center border-bottom pb-3 mb-3">

                              <!-- Left Side: Index Name with Icon -->
                              <div class="col-md-3 d-flex align-items-center justify-content-center mb-2">
                                <i class="bi bi-folder text-primary me-2"></i>
                                <span class="h6 text-primary mb-0">{{ group.key }}</span>
                              </div>

                              <!-- Right Side: Matched Results and Other Details -->
                              <div class="col-md-9">
                                <div class="row g-3">

                                  <!-- Matched Results (First 3 or All if Expanded) -->
                                  <div
                                    *ngFor="let item of getVisibleItems(group.key, group.value); trackBy: trackByItem"
                                    class="col-12">
                                    <a [href]="item?.redirectUrl" rel="noopener noreferrer" class="text-decoration-none"
                                      style="cursor: pointer;">
                                      <div class="border-start border-primary bg-light p-3 rounded shadow-sm h-100">

                                        <!-- Display Key-Value Pairs -->
                                        <div *ngFor="let field of getFields(item.source); trackBy: trackByField"
                                          class="mb-2">
                                          <span class="font-weight-bold text-secondary">{{ field.label }}:</span>
                                          <span class="text-dark text-sm">
                                            <ng-container *ngIf="isFieldValueValid(field.value); else plainText">
                                              {{ field.value | json }}
                                            </ng-container>
                                            <ng-template #plainText>{{ field.value || 'N/A' }}</ng-template>
                                          </span>
                                        </div>
                                      </div>
                                    </a>
                                  </div>
                                </div>

                                <!-- "See More" / "See Less" Button -->
                                <div class="text-center mt-2">
                                  <button *ngIf="group.value.length > 3"
                                    class="btn btn-link text-primary text-decoration-none"
                                    (click)="toggleExpand(group.key)">
                                    {{ expandedIndexes[group.key] ? 'See Less' : 'See More' }}
                                  </button>
                                </div>
                              </div>

                            </div>
                          </div>
                        </div>
                      </div>


                    </div>
                  </div>

                </div>
              </li>
              <li class="nav-item overllmenu dropdown mr-0">
                <a class="headerIcons notification-pointer">
                  <img class="accebility" src="../../assets/images/neveda-images/accebility.svg" alt="accebility">
                </a>
              </li>
              <li class="nav-item overllmenu dropdown mr-0" hidden>
                <a class="headerIcons" href="javascript:void;">
                  <img class="notIcon" src="../../assets/images/neveda-images/notification.svg" alt="Notification">
                </a>
              </li>
              <li class="nav-item userprofile position-relative d-lg-flex d-none">
                <a *showField="'APP_HEADER_PROFILE'" class="nav-link d-flex dropdown-toggle userprofile-link p-0"
                  href="javascript:void(0)" id="navbarDropdownMenuLinkOne" data-toggle="dropdown" aria-haspopup="true"
                  aria-expanded="false">
                  <div class="menuIcons d-flex">
                    <!-- <div class="d-flex flex-column justify-content-center">
                      <span class="username">{{ showname }}</span>
                    </div> -->
                    <img [src]="thumbnail" width="36" alt="profile-pic" class="thumbnail" />
                  </div>
                </a>
                <div class="dropdown-menu" aria-labelledby="navbarDropdownMenuLinkOne">
                  <div class="profileSection clearfix">
                    <div class="menuIcons d-flex">
                      <img [src]="thumbnail" width="36" alt="profile-pic" class="thumbnail ml-0" />
                      <div class="d-flex flex-column justify-content-center">
                        <span class="username">{{ showname }}</span>
                      </div>
                    </div>
                  </div>
                  <a class="dropdown-item d-flex align-items-center notification-pointer"
                    (click)="showDialog(changepassword)" *showField="'APP_HEADER_CHANGE_PASSWORD'">
                    <span class="material-icon material-symbols-outlined mr-2">lock_open</span>
                    Change Password
                  </a>
                  <!-- <a
                    class="dropdown-item"
                    href="javascript:void(0)"
                    [routerLink]="'profile'"
                    (click)="onclicksettings()"
                    *showField="'APP_HEADER_PROFILE'">
                    <span class="material-icon material-symbols-outlined mr-2">settings</span>
                    Settings
                  </a> -->
                  <!-- <a class="dropdown-item" href="javascript:void(0)" [routerLink]="'manage-profile'"
                    (click)="onclickEditProfile()" *showField="'APP_HEADER_PROFILE'">
                    <span class="material-icon material-symbols-outlined mr-2">person</span>
                    Edit Profile
                  </a> -->
                  <a class="dropdown-item clr-red notification-pointer" (click)="onLoggedout()">
                    <span class="material-icon material-symbols-outlined mr-2">logout</span>
                    Log Out
                  </a>
                </div>
              </li>
            </ul>
          </div>
        </nav>

        <div class="d-lg-none d-block pt-3 pl-3 content-header">
          <div class="content-text">{{ pagename }}</div>
        </div>
      </header>
    </div>
    <app-ticker></app-ticker>
    <ng-template #changepassword let-modal>
      <div class="modal-body">
        <div [formGroup]="resetPasswordForm" class="reset-password-div">

          <div class="mb-3">
            <label for="input_pages_email" aria-describedby="mailid">Email</label>
            <input 
              type="text" 
              readonly="true" 
              id='input_pages_email' 
              formControlName="mailid" 
              pInputText 
            />
          </div>

          <!-- Current password field Start... -->
          <div class="mb-3">

            <label for="input_pages_currentPassword" aria-describedby="cpassword">Current Password <span class="requiredfield">*</span></label>
            <p-password 
              [placeholder]="placeholderMessage[P0026]"
              class="position-relative" 
              inputId="input_pages_currentPassword" 
              formControlName="currentpassword"
              [toggleMask]="true" 
              [feedback]="false" 
              autocomplete="off">
            </p-password>

            <small id="errorCaps_pages_currentPassword" *ngIf="isCapsLockOnCurrent" class="p-error block">
              {{errorMessage['M0037']}}
            </small><br>
            <small id="errorInvalid_pages_currentPassword" *ngIf="isCurrentPasswordInvalid" class="p-error block">
              {{errorMessage['M0112']}}
            </small>

          </div>
          <!-- Current password field End... -->

          <!-- New password field Start... -->
          <div class="mb-3 position-relative">

            <label for="input_pages_newPassword" aria-describedby="npassword"> New Password <span class="requiredfield">*</span></label>
            <p-password 
              [placeholder]="placeholderMessage[P0020]"
              class="position-relative" 
              appBlockcutcopypaste 
              inputId="input_pages_newPassword"
              formControlName="newpassword"
              [toggleMask]="true" 
              [feedback]="false">
            </p-password>

            <small *ngIf="isCapsLockOnNew" class="p-error block">
              {{errorMessage['M0037']}}
            </small>
            <div class="validation-item text-danger err-font" *ngIf="isNewPasswordInvalid">
              {{errorMessage['M0026']}}
            </div>

            <div class="validation-list my-1" *ngIf="newPassword.value && !newPassword.valid">
              <div class="validation-item" *ngFor="let rule of passwordValidationRules" [ngClass]="{ 'valid': rule.isValid() }">
                {{ rule.message }}
              </div>
            </div>

          </div>
          <!-- New password field End... -->

          <!-- Confirm Password field Start... -->
          <div class="mb-2">
            <label for="input_pages_confirmPassword" aria-describedby="cnfpassword"> Confirm Password <span class="requiredfield">*</span></label>
            <p-password 
              [placeholder]="placeholderMessage[P0021]"
              appBlockcutcopypaste 
              class="position-relative" 
              inputId="input_pages_confirmPassword"
              formControlName="conformpassword" 
              [toggleMask]="true" 
              [feedback]="false">
            </p-password>
            
            <small *ngIf="isCapsLockOnConfirm" class="p-error block">
              {{errorMessage['M0037']}}
            </small>

            <div class="validation-item text-danger err-font"
              *ngIf="!resetFormcontrols['conformpassword'].disabled && !resetFormcontrols['conformpassword'].value && (resetFormcontrols['conformpassword'].touched || resetFormcontrols['conformpassword'].dirty)">
              {{errorMessage['M0035']}}
            </div>

            <div class="validation-item text-danger err-font"
              *ngIf="resetFormcontrols['conformpassword'].value && resetFormcontrols['conformpassword'].hasError('NoPassswordMatch')">
              Password does not match
            </div>

          </div>
          <!-- Confirm Password field End... -->

        </div>
      </div>
      <div class="modal-footer p-3">
        <p-button label="Cancel" styleClass="btn-cancel px-3 py-1 mr-2 " (click)="modal.dismiss('Cross click')">
        </p-button>
        <p-button label="Save" styleClass="px-3 py-1" (click)="changePassword()" [disabled]="resetPasswordForm.invalid">
        </p-button>
      </div>
    </ng-template>
    <ng-template #notificationAlert let-modal>
      <div class="modal-body p-3">
        <div class="reset-password-div">A new task has been assigned to you ( {{ notificationMessage }} )</div>
      </div>
      <div class="modal-footer p-3">
        <p-button label="Accept" styleClass="btn px-3 py-1 mr-2 " (click)="updateNotification()"> </p-button>
      </div>
    </ng-template>
    <div class="d-flex scrollSection">
      <div class="container-fluid overallSec clearfix pt-md-2 pt-2" [class.active]="active">
        <router-outlet></router-outlet>
      </div>
      <div class="pt-md-4 pt-2 active-log" *ngIf="activityLogPageload | async" [class.active]="active">
        <app-activity-logs></app-activity-logs>
      </div>
    </div>
    <ng-template #assistanceOpen let-modal>
      <div class="modal-body p-3">
        <div class="apply-assistance-group">
          <h5>Select the program</h5>
          <ul class="program-group">
            <li class="program-list" [ngClass]="{ active: step === 'step1' }" (click)="step = 'step1'">
              <svg width="50" height="50" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M36.7185 25C37.7665 24.9185 38.8207 25.0002 39.8435 25.2422C40.0295 25.2886 40.2236 25.2919 40.411 25.2519C40.5984 25.2119 40.7742 25.1296 40.9249 25.0112C41.0757 24.8929 41.1974 24.7417 41.2808 24.5691C41.3641 24.3966 41.407 24.2073 41.406 24.0156V15.7969C41.4049 15.6616 41.372 15.5284 41.3102 15.4081C41.2483 15.2877 41.1591 15.1836 41.0498 15.1038C40.9405 15.0241 40.814 14.9711 40.6805 14.949C40.547 14.9269 40.4102 14.9363 40.281 14.9766L25.4373 19.6641C25.0789 19.7756 24.7664 20.0004 24.5466 20.3046C24.3269 20.6089 24.2117 20.9763 24.2185 21.3516V39.9062C24.2176 40.0792 24.2577 40.2499 24.3355 40.4043C24.4133 40.5588 24.5266 40.6925 24.6661 40.7947C24.8056 40.8969 24.9674 40.9645 25.1381 40.992C25.3088 41.0196 25.4837 41.0062 25.6482 40.9531L27.2107 40.4609C27.3789 40.41 27.5349 40.3253 27.6691 40.2119C27.8033 40.0985 27.913 39.9588 27.9912 39.8015C28.0695 39.6442 28.1148 39.4726 28.1244 39.2971C28.1339 39.1217 28.1075 38.9461 28.0467 38.7812C27.5656 37.5604 27.3267 36.2575 27.3435 34.9453C27.4077 32.4242 28.3997 30.0153 30.1296 28.1802C31.8595 26.3451 34.2056 25.2127 36.7185 25Z"
                  fill="#BDBDBD" />
                <path
                  d="M37.5 28.125C36.1094 28.125 34.7499 28.5374 33.5936 29.31C32.4374 30.0826 31.5362 31.1807 31.004 32.4655C30.4718 33.7503 30.3326 35.164 30.6039 36.528C30.8752 37.8919 31.5448 39.1448 32.5282 40.1281C33.5115 41.1114 34.7643 41.7811 36.1283 42.0524C37.4922 42.3237 38.906 42.1845 40.1907 41.6523C41.4755 41.1201 42.5737 40.2189 43.3463 39.0626C44.1189 37.9063 44.5313 36.5469 44.5313 35.1562C44.5313 33.2914 43.7905 31.503 42.4718 30.1844C41.1532 28.8658 39.3648 28.125 37.5 28.125ZM39.8438 36.7187H39.0625V37.5C39.0625 37.9144 38.8979 38.3118 38.6049 38.6049C38.3118 38.8979 37.9144 39.0625 37.5 39.0625C37.0856 39.0625 36.6882 38.8979 36.3951 38.6049C36.1021 38.3118 35.9375 37.9144 35.9375 37.5V36.7187H35.1563C34.7419 36.7187 34.3444 36.5541 34.0514 36.2611C33.7584 35.9681 33.5938 35.5706 33.5938 35.1562C33.5938 34.7418 33.7584 34.3444 34.0514 34.0514C34.3444 33.7584 34.7419 33.5937 35.1563 33.5937H35.9375V32.8125C35.9375 32.3981 36.1021 32.0007 36.3951 31.7076C36.6882 31.4146 37.0856 31.25 37.5 31.25C37.9144 31.25 38.3118 31.4146 38.6049 31.7076C38.8979 32.0007 39.0625 32.3981 39.0625 32.8125V33.5937H39.8438C40.2582 33.5937 40.6556 33.7584 40.9486 34.0514C41.2416 34.3444 41.4063 34.7418 41.4063 35.1562C41.4063 35.5706 41.2416 35.9681 40.9486 36.2611C40.6556 36.5541 40.2582 36.7187 39.8438 36.7187Z"
                  fill="#BDBDBD" />
                <path
                  d="M19.8831 19.7031L13.969 17.8203C13.8902 17.796 13.8067 17.7905 13.7254 17.804C13.644 17.8176 13.5669 17.8499 13.5002 17.8984C13.4335 17.9469 13.379 18.0103 13.341 18.0835C13.3031 18.1568 13.2827 18.2378 13.2815 18.3203V24.6484C13.2805 24.7066 13.261 24.7629 13.2258 24.8092C13.1907 24.8555 13.1417 24.8894 13.0859 24.906C13.0302 24.9225 12.9706 24.9209 12.9158 24.9013C12.8611 24.8816 12.814 24.8451 12.7815 24.7969L11.8518 23.4375C11.8149 23.3815 11.7587 23.341 11.6939 23.3237C11.6291 23.3064 11.5601 23.3135 11.5002 23.3438L10.5549 23.8203C10.5127 23.842 10.4656 23.8524 10.4182 23.8504C10.3708 23.8483 10.3247 23.834 10.2845 23.8088C10.2443 23.7836 10.2114 23.7483 10.1889 23.7065C10.1665 23.6647 10.1553 23.6178 10.1565 23.5703V17.125C10.1566 16.9843 10.112 16.8472 10.0292 16.7334C9.94635 16.6197 9.82951 16.5352 9.69555 16.4922L5.00805 15C4.88219 14.9645 4.74993 14.958 4.62118 14.9809C4.49243 15.0037 4.37052 15.0554 4.26458 15.1321C4.15863 15.2087 4.07138 15.3083 4.00937 15.4235C3.94736 15.5386 3.91219 15.6662 3.90649 15.7969V34.7578C3.90052 35.1047 4.00683 35.4443 4.20956 35.7259C4.41229 36.0074 4.7006 36.2159 5.03149 36.3203L19.6643 41.0078C19.8334 41.0627 20.0133 41.0755 20.1884 41.0452C20.3636 41.0149 20.5287 40.9424 20.6695 40.8339C20.8103 40.7254 20.9226 40.5842 20.9965 40.4226C21.0705 40.261 21.1039 40.0837 21.094 39.9063V21.3516C21.0929 20.9839 20.975 20.6261 20.7574 20.3298C20.5397 20.0335 20.2336 19.8141 19.8831 19.7031Z"
                  fill="#BDBDBD" />
                <path
                  d="M6.25 12.0391L10.6328 13.5625C10.9899 13.6845 11.3773 13.6845 11.7344 13.5625L28.0703 8.09375C28.1163 8.07636 28.156 8.04537 28.184 8.00489C28.2119 7.96442 28.2269 7.91639 28.2269 7.86718C28.2269 7.81798 28.2119 7.76995 28.184 7.72947C28.156 7.689 28.1163 7.65801 28.0703 7.64062L24.1094 6.46875C23.1621 6.18052 22.1504 6.18052 21.2031 6.46875L6.25 11.0078C6.13951 11.0415 6.04276 11.1098 5.97402 11.2026C5.90527 11.2955 5.86816 11.4079 5.86816 11.5234C5.86816 11.6389 5.90527 11.7514 5.97402 11.8442C6.04276 11.9371 6.13951 12.0054 6.25 12.0391Z"
                  fill="#BDBDBD" />
                <path
                  d="M39.0496 11.3885L32.7996 9.48226C32.3685 9.33925 31.9027 9.33925 31.4715 9.48226L15.8465 15.1073C15.7821 15.1281 15.726 15.1689 15.6862 15.2236C15.6464 15.2783 15.625 15.3443 15.625 15.4119C15.625 15.4796 15.6464 15.5455 15.6862 15.6003C15.726 15.655 15.7821 15.6958 15.8465 15.7166L21.3699 17.6385C22.2099 17.9302 23.1237 17.9302 23.9637 17.6385L39.0496 12.4198C39.1601 12.3861 39.2569 12.3178 39.3256 12.2249C39.3944 12.1321 39.4315 12.0196 39.4315 11.9041C39.4315 11.7886 39.3944 11.6762 39.3256 11.5833C39.2569 11.4905 39.1601 11.4222 39.0496 11.3885Z"
                  fill="#BDBDBD" />
              </svg>
              <p class="mb-0">SNAP</p>
            </li>
            <li class="program-list" [ngClass]="{ active: step === 'step2' }" (click)="step = 'step2'">
              <svg width="38" height="38" viewBox="0 0 38 38" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M18.5299 8.90625C20.9247 8.90625 22.866 6.91252 22.866 4.45312C22.866 1.99373 20.9247 0 18.5299 0C16.1352 0 14.1938 1.99373 14.1938 4.45312C14.1938 6.91252 16.1352 8.90625 18.5299 8.90625Z"
                  fill="#BDBDBD" />
                <path
                  d="M13.1099 18.9258H23.9502C24.5488 18.9258 25.0342 18.4273 25.0342 17.8125V14.4727C25.0342 12.4795 24.1795 10.6878 22.827 9.46289C20.3699 11.6883 16.6934 11.6913 14.233 9.46289C12.8806 10.6878 12.0259 12.4795 12.0259 14.4727V17.8125C12.0259 18.4273 12.5112 18.9258 13.1099 18.9258Z"
                  fill="#BDBDBD" />
                <path
                  d="M16.3768 26.7432L12.9365 23.2475C11.3785 21.6609 8.97709 21.4791 7.22574 22.6988C6.85139 22.9596 6.80369 23.508 7.12348 23.8364L11.4375 28.2669C11.8147 28.6542 11.7944 29.2883 11.3933 29.6494C11.0266 29.9794 10.4732 29.9595 10.1299 29.6039L5.52165 24.829V13.916C5.52165 12.6658 4.53482 11.6523 3.31747 11.6523C2.10011 11.6523 1.11328 12.6658 1.11328 13.916V24.6208C1.11328 26.0106 1.65551 27.3425 2.6187 28.3187L8.07077 33.8442V36.8867C8.07077 37.5015 8.55612 38 9.15479 38H16.3619C16.9606 38 17.4459 37.5015 17.4459 36.8867V29.3783C17.4459 28.3887 17.061 27.4401 16.3768 26.7432Z"
                  fill="#BDBDBD" />
                <path
                  d="M20.6829 26.7432L24.1232 23.2475C25.6812 21.6609 28.0826 21.4791 29.834 22.6988C30.2083 22.9596 30.256 23.508 29.9362 23.8364L25.6222 28.2669C25.245 28.6542 25.2653 29.2883 25.6664 29.6494C26.0331 29.9794 26.5865 29.9595 26.9298 29.6039L31.538 24.829V13.916C31.538 12.6658 32.5249 11.6523 33.7422 11.6523C34.9596 11.6523 35.9464 12.6658 35.9464 13.916V24.6208C35.9464 26.0106 35.4042 27.3425 34.441 28.3187L28.9889 33.8442V36.8867C28.9889 37.5015 28.5036 38 27.9049 38H20.6978C20.0991 38 19.6138 37.5015 19.6138 36.8867V29.3783C19.6138 28.3887 19.9987 27.4401 20.6829 26.7432Z"
                  fill="#BDBDBD" />
              </svg>
              <p class="mb-0">TANF</p>
            </li>
            <li class="program-list" [ngClass]="{ active: step === 'step3' }" (click)="step = 'step3'">
              <svg width="38" height="38" viewBox="0 0 38 38" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M21.2218 17.5219H24.8032V19.7385H21.2218C20.6066 19.7385 20.1087 20.2372 20.1087 20.8516V24.4337H17.892V20.8516C17.892 20.2372 17.3941 19.7385 16.7789 19.7385H13.1968V17.5219H16.7789C17.3941 17.5219 17.892 17.0239 17.892 16.4087V12.8266H20.1087V16.4087C20.1087 17.0238 20.6066 17.5219 21.2218 17.5219Z"
                  fill="#BDBDBD" />
                <path
                  d="M35.102 10.3065L35.1013 10.2701C35.0834 9.32318 35.0664 8.42821 35.0664 7.56738C35.0664 6.26277 34.0052 5.20232 32.7013 5.20232C27.6551 5.20232 23.8251 3.76339 20.6482 0.674047C19.7235 -0.224632 18.275 -0.224632 17.3503 0.674047C14.1741 3.76339 10.3442 5.20232 5.29868 5.20232C3.99481 5.20232 2.93362 6.26277 2.93362 7.56738C2.93362 8.44602 2.91655 9.3499 2.898 10.3072C2.81265 14.7746 2.70654 20.3344 4.57216 25.3814C5.59848 28.1568 7.15169 30.5679 9.18949 32.5493C11.5108 34.806 14.5504 36.596 18.2245 37.8694C18.4746 37.9562 18.7351 38 18.9993 38C19.2634 38 19.5247 37.9562 19.774 37.8694C23.4481 36.596 26.4885 34.806 28.8098 32.5493C30.8476 30.5679 32.4008 28.1561 33.4271 25.3814C35.2935 20.3337 35.1873 14.7739 35.102 10.3065ZM27.0295 20.8516C27.0295 21.466 26.5315 21.9647 25.9163 21.9647H22.335V25.5468C22.335 26.1613 21.8363 26.66 21.2218 26.66H16.7789C16.1644 26.66 15.6658 26.1613 15.6658 25.5468V21.9647H12.0837C11.4685 21.9647 10.9705 21.466 10.9705 20.8516V16.4086C10.9705 15.7942 11.4685 15.2955 12.0837 15.2955H15.6658V11.7134C15.6658 11.0989 16.1644 10.6003 16.7789 10.6003H21.2218C21.8363 10.6003 22.335 11.0989 22.335 11.7134V15.2955H25.9163C26.5315 15.2955 27.0295 15.7942 27.0295 16.4086V20.8516Z"
                  fill="#BDBDBD" />
              </svg>
              <p class="mb-0">Medicaid</p>
            </li>
            <li class="program-list" [ngClass]="{ active: step === 'step4' }" (click)="step = 'step4'">
              <svg width="38" height="38" viewBox="0 0 38 38" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g clip-path="url(#clip0_1017_750)">
                  <path
                    d="M9.06578 15.6253C9.00938 15.246 8.98043 14.8608 8.98043 14.4726C8.98043 10.1754 12.4761 6.67972 16.7734 6.67972C19.1721 6.67972 21.3771 7.78558 22.8251 9.56756L29.2153 6.75394L29.3689 6.60031L24.6457 1.87706L22.7353 3.78744C21.8996 3.31764 21.0224 2.951 20.1132 2.69123V7.62939e-05H13.4335V2.69123C12.5244 2.951 11.6471 3.31764 10.8114 3.78744L8.90102 1.87706L4.17776 6.60031L6.08814 8.51069C5.61834 9.34639 5.2517 10.2229 4.99194 11.1328H2.30078V17.8125H4.09835L9.06578 15.6253Z"
                    fill="#BDBDBD" />
                  <path
                    d="M34.6733 9.21672L34.0038 11.0559L36.0962 11.8174L38 6.58672L32.7692 4.68288L32.0078 6.77517L33.4779 7.31028L0.000488281 22.0497L0.897639 24.0875L34.6733 9.21672Z"
                    fill="#BDBDBD" />
                  <path d="M0 35.7733H37.9998V37.9998H0V35.7733Z" fill="#BDBDBD" />
                  <path d="M11.207 24.6406H17.8867V33.5468H11.207V24.6406Z" fill="#BDBDBD" />
                  <path d="M20.1133 20.1875H26.7929V33.5468H20.1133V20.1875Z" fill="#BDBDBD" />
                  <path d="M29.0195 13.5078H35.6992V33.5467H29.0195V13.5078Z" fill="#BDBDBD" />
                  <path d="M2.30078 29.0937H8.98047V33.5468H2.30078V29.0937Z" fill="#BDBDBD" />
                </g>
                <defs>
                  <clipPath id="clip0_1017_750">
                    <rect width="38" height="38" fill="white" />
                  </clipPath>
                </defs>
              </svg>
              <p class="mb-0">Other Programs</p>
            </li>
          </ul>
        </div>
      </div>
      <div class="modal-footer p-3">
        <p-button label="Cancel" styleClass="btn-cancel px-3 py-1 mr-2 " (click)="modal.dismiss('Cross click')">
        </p-button>
        <p-button label="Next" styleClass="px-3 py-1" (click)="navtoMyApplication()" [disabled]="!step"> </p-button>
      </div>
    </ng-template>
  </div>
</div>

<div class="customizer d-none" [ngClass]="showThemeCustomizer ? 'show' : 'hidden'">
  <a class="customizer-toggle d-flex align-items-center justify-content-center" (click)="settingclick()">
    <span data-feather="settings" class="fa fa-cog"></span>
  </a>
  <div class="customizer-header p-3 position-relative">
    <h4 class="mb-0">Theme Customizer</h4>
    <p class="m-0">Customize & Preview in Real Time</p>

    <a class="customizer-close" (click)="settingclick()"><span
        class="material-icon material-symbols-outlined">close</span></a>
  </div>
  <hr />
  <div class="customizer-styling p-3">
    <!-- Skin -->
    <div class="customizer-styling-skin mb-3">
      <h6 class="font-weight-bold mb-2">Skin</h6>
      <div class="d-flex justify-content-start align-items-center">
        <div *ngFor="let theme of themes" class="custom-control custom-radio mr-3">
          <input type="radio" id="theme_{{ theme.key }}" name="{{ theme.name }}"
            class="custom-control-input layout-name" [value]="theme.key" [(ngModel)]="selectedTheme"
            (click)="setTheme(theme.key)" />
          <label class="custom-control-label" for="theme_{{ theme.key }}">{{ theme.name }}</label>
        </div>
      </div>
    </div>

    <div class="customizer-styling-skin mb-3">
      <h6 class="font-weight-bold mb-2">Font</h6>
      <div class="d-flex justify-content-start align-items-center">
        <div *ngFor="let FontSet of fontSetList" class="custom-control custom-radio mr-3">
          <input type="radio" id="font_{{ FontSet.key }}" name="{{ FontSet.name }}"
            class="custom-control-input layout-name" [value]="FontSet.key" [(ngModel)]="selectedFont"
            (click)="setFont(FontSet.key)" />
          <label class="custom-control-label" for="font_{{ FontSet.key }}">{{ FontSet.name }}</label>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="modal" #sessionModal id="SessionExpired" tabindex="-1" role="dialog">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header bg-white d-block border-0 px-3">
        <h5 class="term-title py-0 mb-0">You're About To Be Logged Out</h5>
      </div>
      <div class="modal-body text-left px-3 py-2">
        <div class="clearfix mb-4">
          <div class="mb-3">
            For your security, you will be logged out soon due to inactivity. If you're still using the system, please select Stay Logged In to continue your session.
          </div>
          <div id="countdown" class="font-weight-bold">Time Remaining: {{ countdownMin }}</div>
        </div>
        <div class="pull-right mt-2 d-flex">
          <button class="mb-2 mr-2 btn bg-white text-primary btncancel d-flex" data-dismiss="modal"
            (click)="onLoggedout()">
            <span class="material-icon material-symbols-outlined mr-2" aria-hidden="true">close</span>Log Out Now
          </button>
          <button class="mb-2 btn btn-primary btncommon delete d-flex" data-dismiss="modal" (click)="resetIdleTimer()">
            <span class="material-icon material-symbols-outlined mr-2" aria-hidden="true">check_circle</span>Stay Logged
            In
          </button>
        </div>
        <div class="clearfix"></div>
      </div>
    </div>
  </div>
</div>

<div class="modal" id="noInternet" tabindex="-1" role="dialog">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-body text-center">
        <div class="no-internet">No Internet Connection</div>
        <p class="mb-0">Please check your connection and try again.</p>
      </div>
    </div>
  </div>
</div>

<div class="modal" id="noInternetWithTimmer" tabindex="-1" role="dialog">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-body">
        <p>
          Your application will be closed in {{ countdown }} {{ countdown > 1 ? 'seconds' : 'second' }}. Please check
          your Internet Connection.
        </p>
      </div>
    </div>
  </div>
</div>
<app-chat-widget botName="Cardinality" theme="blue"></app-chat-widget>
<div class="env" *ngIf="environment">
  {{ environment }}
</div>

<!-- main loader -->
<div id="loaderAnimation" class="loaderAnimation">
  <div class="loadingGifAnimation clearfix">
    <div class="loadingInner clearfix">
      <img class="logoCenterLoading" src="assets/images/Loader-new.gif" alt="Loader-new" />
    </div>
  </div>
</div>